/**
 * @ignore
 * Created by daletan on 8/25/16.
 */

'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const Relay = require('react-relay');

// Stores
const ItemStore = require('../../stores/ItemStore.es');
const UserStore = require('../../../global/stores/UserStore.es');
const PriceStore = require('../../../global/stores/PriceStore.es.js');
const TourStore = require('../../../components/Tour/TourStore.es');

const { OPEN_DETAILS_FROM_DESCRIPTION } = require('../../constants/shippingConstants.es');

// Components
const VerifiedTradePromo = require('./VerifiedTradePromo/VerifiedTradePromo').default;
const Tour = require('../../../components/Tour/Tour');
const QuotePrimary = require('./QuotePrimary');
const QuoteHandling = require('./QuoteHandling');
const QuoteSecondary = require('./QuoteSecondary');
const ShippingDetailsLink = require('./ShippingDetailsLink');

// Helpers
const { filterQuotes } = require('./shippingHelpers.es');
const provideContext = require('fluxible-addons-react/provideContext');
const connectToStores = require('fluxible-addons-react/connectToStores');
const tourTracking = require('../../../global/tracking/tourTracking.es');
const {type: {TRADE_TOUR}} = TourStore;
const SV = require('server-vars');
const get = require('lodash.get');

// Styles
const styles = require('./shipping-styles.scss');


const DetailsShipping = (props) => {
    const { quotes, tradeTour, currency, context, copy, user, userId,
        itemIsSold, itemIsUnlisted, itemId, dealerPk, viewer,
        favoriteDealerCta, favoriteDealer, dealerData, item } = props;
    const { estimateTitle: shippingTitle } = copy;
    const canRequestShippingQuote = get(user, 'canRequestShippingQuote');

    const hasQuote = filterQuotes(quotes.domestic).length || filterQuotes(quotes.local).length;
    const linkQuoteCopy = hasQuote ? copy.hasQuote : copy.noQuote;

    const link = (
        <a className="pdp-shipping-link" href="#" data-tn='pdp-shipping-modal-link'>
            {canRequestShippingQuote ? linkQuoteCopy.canRequest : linkQuoteCopy.cannotRequest}
        </a>
    );

    return (
        <div className="pdp-details-entry-content-container">
            <div className="pdp-details-entry-title-container">
                <Tour step={4} {...tradeTour} dataTn="details-shipping-trade" className={styles.shippingTitle}>
                    <div className="pdp-shipping-title">{shippingTitle}</div>
                </Tour>
            </div>
            <div className="pdp-shipping-entry">
                <QuotePrimary quotes={quotes} currency={currency} />
                <QuoteHandling quotes={quotes} currency={currency} />
                <QuoteSecondary quotes={quotes} currency={currency} />
                <VerifiedTradePromo userId={userId} itemId={itemId} viewer={viewer} />
            </div>
            {!itemIsSold && !itemIsUnlisted &&
                <div className="pdp-shipping-link-container">
                    <ShippingDetailsLink
                        pagePosition={'details-shipping'}
                        context={context}
                        user={user}
                        userId={userId}
                        itemId={itemId}
                        dealerPk={dealerPk}
                        viewer={viewer}
                        quotes={quotes}
                        link={link}
                        regionType="DOMESTIC"
                        source={OPEN_DETAILS_FROM_DESCRIPTION}
                        favoriteDealer={favoriteDealer}
                        favoriteDealerCta={favoriteDealerCta}
                        dealerData={dealerData}
                        trackingLocation="pdp description"
                        item={item}
                    />
                </div>
            }
        </div>
    );
};

DetailsShipping.propTypes = {
    context: PropTypes.object,
    hidePrice: PropTypes.bool.isRequired,
    quotes: PropTypes.object.isRequired,
    user: PropTypes.object,
    userId: PropTypes.string,
    itemIsSold: PropTypes.bool,
    itemIsUnlisted: PropTypes.bool,
    itemId: PropTypes.string,
    dealerPk: PropTypes.string,
    viewer: PropTypes.object,
    currency: PropTypes.string.isRequired,
    copy: PropTypes.object.isRequired,
    tradeTour: PropTypes.object.isRequired,
    favoriteDealer: PropTypes.object,
    favoriteDealerCta: PropTypes.object,
    dealerData: PropTypes.object,
    item: PropTypes.object
};

module.exports = Relay.createContainer(provideContext(connectToStores(
    DetailsShipping,
    [
        ItemStore,
        PriceStore,
        TourStore,
        UserStore
    ],
    context => {
        const userStore = context.getStore(UserStore);
        const itemStore = context.getStore(ItemStore);
        const item = itemStore.getItem();
        const priceStore = context.getStore(PriceStore);
        const { priceDisplays } = priceStore.processPrice(item);
        const tourStore = context.getStore(TourStore);
        return ({
            hidePrice: itemStore.getHidePrice(),
            currency: userStore.getCurrency(),
            copy: itemStore.getCopy().shipping,
            tradeTour: {
                type: TRADE_TOUR,
                subType: priceDisplays.showNetPrice ? 'preQuotedNetPrice' : 'requestNetPrice',
                copy: SV.get(`tourCopy.${TRADE_TOUR}`),
                isTourOpen: tourStore.isTourOpen(TRADE_TOUR),
                currentStep: tourStore.getCurrentStep(TRADE_TOUR),
                totalSteps: tourStore.getTotalSteps(TRADE_TOUR),
                onOpen: tourTracking.trackOpen,
                onClose: tourTracking.trackClose
            }
        });
    }
)), {
    initialVariables: {
        itemId: null,
        userId: null
    },
    fragments: {
        user: ({itemId, userId}) => Relay.QL`
            fragment on User {
                canRequestShippingQuote: hasPermission(name: "B_REQUEST_SHIPPING_QUOTE")
                ${ShippingDetailsLink.getFragment('user', {itemId, userId})}
            }
        `,
        item: () => Relay.QL`
            fragment on Item {
                ${ShippingDetailsLink.getFragment('item')}
            }
        `,
        viewer: ({itemId, userId}) => Relay.QL`
            fragment on Viewer {
                ${ShippingDetailsLink.getFragment('viewer', {itemId, userId})}
                ${VerifiedTradePromo.getFragment('viewer', {itemId, userId})}
            }
        `
    }
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Shipping/DetailsShipping.jsx